import { useState } from "react";
import { motion } from "framer-motion";
import { auth, database } from "../Firebase/firebaseConfig"; // Firebase setup file
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import { ref, set } from "firebase/database";
import logoImg from "../assets/sportLogo.png";
const SignUpOverlayContent = ({
  darkMode,
  showEmailVerificationOverlay,
  handleLoginClick,
  setUsername,
  setPassword,
  toggleOverlay
}) => {
  const [signUpFirstName, setSignUpFirstName] = useState("");
  const [signUpLastName, setSignUpLastName] = useState("");
  const [signUpPhone, setSignUpPhone] = useState("");
  const [signUpEmail, setSignUpEmail] = useState("");
  const [signUpAddress, setSignUpAddress] = useState("");
  const [signUpPassword, setSignUpPassword] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [errorMessage, setErrorMessage] = useState(""); // For Firebase error messages

  // Input Handlers
  const handleFirstNameChange = (e) => setSignUpFirstName(e.target.value);
  const handleLastNameChange = (e) => setSignUpLastName(e.target.value);
  const handlePhoneChange = (e) => setSignUpPhone(e.target.value);
  const handleEmailChange = (e) => setSignUpEmail(e.target.value);
  const handleAddressChange = (e) => setSignUpAddress(e.target.value);
  const handlePasswordChange = (e) => {
    setSignUpPassword(e.target.value);
    setErrorMessage(""); // Clear error when user modifies the password
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        signUpEmail,
        signUpPassword
      );
      const user = userCredential.user;

      await sendEmailVerification(user);
      setIsSubmitted(true);
      showEmailVerificationOverlay(true);

      const intervalId = setInterval(async () => {
        await user.reload();

        if (user.emailVerified) {
          showEmailVerificationOverlay(false);

          await set(ref(database, `users/${user.uid}`), {
            firstName: signUpFirstName,
            lastName: signUpLastName,
            phone: signUpPhone,
            email: signUpEmail,
            address: signUpAddress,
            createdAt: new Date().toISOString(),
            uid: user.uid,
            isActive: true,
            password: signUpPassword,
          });

          toggleOverlay();
          setUsername(signUpEmail);
          setPassword(signUpPassword);
          handleLoginClick();
          clearInterval(intervalId);
        }
      }, 3000);
    } catch (error) {
      if (error.code === "auth/weak-password") {
        setErrorMessage("Password should be at least 6 characters.");
      } else if (error.code === "auth/email-already-in-use") {
        setErrorMessage("This email is already in use.");
      } else {
        setErrorMessage("Failed to create account. Please try again.");
      }
      console.error("Error creating account:", error);
    }
  };

  return (
    <motion.div
      className={
        darkMode.value
          ? "dark-mode signup-container flex-column align-items-center relative w-full"
          : "flex-column align-items-end signup-container relative w-full"
      }
    >
      <div className="w-full">
        <img
          alt=""
          src={logoImg}
          className={darkMode ? "inverted-image logo-img" : "logo-img"}
        />
        <div className="my-20">
          <p>Account Creation</p>
          <p className="small-text grey">SportMat Accounts.</p>
        </div>
      </div>

      <form
        onSubmit={handleSubmit}
        className="account-creation-form flex-column w-full"
      >
        <div className="input-container my-10">
          <p className="label small-text">First Name</p>
          <input
            type="text"
            placeholder="Enter your first name"
            value={signUpFirstName}
            onChange={handleFirstNameChange}
            required
          />
        </div>

        <div className="input-container my-10">
          <p className="label small-text">Last Name</p>
          <input
            type="text"
            placeholder="Enter your last name"
            value={signUpLastName}
            onChange={handleLastNameChange}
            required
          />
        </div>

        <div className="input-container my-10">
          <p className="label small-text">Email</p>
          <input
            type="email"
            placeholder="Enter your email"
            value={signUpEmail}
            onChange={handleEmailChange}
            required
          />
        </div>

        <div className="input-container my-10">
          <p className="label small-text">Password</p>
          <input
            type="password"
            placeholder="Enter your password"
            value={signUpPassword}
            onChange={handlePasswordChange}
            required
          />
          
        </div>

        <div className="input-container my-10">
          <p className="label small-text">Phone</p>
          <input
            type="number"
            placeholder="Enter your phone number"
            value={signUpPhone}
            onChange={handlePhoneChange}
            required
          />
        </div>

        <div className="input-container my-10">
          <p className="label small-text">Address</p>
          <input
            type="text"
            placeholder="Enter your address"
            value={signUpAddress}
            onChange={handleAddressChange}
            required
          />
        </div>

        <div className="flex align-items-center justify-end ">
        {errorMessage && (
            <motion.p
              className="small-text grey mx-20"
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              {errorMessage}
            </motion.p>
          )}

          <button type="submit" className="action-button bg-red my-20">
            <p className="btn">Create Account</p>
          </button>
        </div>
      </form>
    </motion.div>
  );
};

export default SignUpOverlayContent;
